import React, { useState } from 'react';
import Webcam from "react-webcam";


export interface IWebCamCaptureProps {
    hanldeWebCamPhotoSubmit: any,
}

const videoConstraints = {
    width: 220,
    height: 200,
    facingMode: "user"
};
export function WebCamCapture(props: IWebCamCaptureProps) {
    const { hanldeWebCamPhotoSubmit } = props

    const webcamRef: any = React.useRef(null);
    const [image, setImage] = useState('')

    const capture = React.useCallback(
        () => {
            const imageSrc = webcamRef?.current?.getScreenshot();
            setImage(imageSrc)
        }, []);



    return (
        <div className="webcam-container">
            <div className="webcam-img">

                {image === '' ? <Webcam
                    audio={false}
                    height='100%'
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                    width='100%'
                // videoConstraints={videoConstraints}
                /> : <img src={image} />}
            </div>
            <div className="mt-5 mb-2">
                {image !== ''
                    ? <div>
                        <button onClick={(e) => { e.preventDefault(); setImage('') }}
                            className="gradientBtn flex justify-center items-center text-white text-base font-medium mx-auto px-2 py-1.5 rounded-md">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                            </svg>

                            <p>Retake</p>
                        </button>
                        <button
                            onClick={() => hanldeWebCamPhotoSubmit(image)}
                            className="gradientBtn flex justify-center items-center text-white text-base font-medium mx-auto px-5 py-1.5 rounded-md mt-4">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <p>Submit</p>
                        </button>
                    </div>

                    : <button onClick={(e) => {
                        e.preventDefault();
                        capture();
                    }}
                        className="gradientBtn text-white text-base font-medium px-5 py-1.5 mx-auto rounded-md">Capture</button>
                }
            </div>
        </div>
    );
}

export default WebCamCapture;